import { DataType } from '@/domains/base/enums/data-type';
import { ViewType } from '@/domains/base/enums/view-type';
import { PATENT_VIEW_TYPE_MAP } from './constants';
export function transferViewTypeForApi(dataType, viewType) {
    if (dataType === DataType.PATENT) {
        return PATENT_VIEW_TYPE_MAP[viewType];
    }
    return PATENT_VIEW_TYPE_MAP[ViewType.TABLE];
}
export function transferViewType2legacy(dataType, viewType) {
    if (dataType === DataType.PATENT) {
        return viewType || ViewType.TABLE;
    }
    return ViewType.TABLE;
}
